









































import { defineComponent } from '@vue/composition-api';
import {
    SdsAlert,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import alertsStore from './alertsStore';

export default defineComponent({
    name: 'AlertsContainer',
    setup() {
        const alertsModule = useVuexStore<typeof alertsStore>('ui/alerts');
        const alerts = alertsModule.getter('alerts');
        return { alerts };
    },
    components: {
        SdsAlert,
        SdsIcon,
    },
});
